template.tips_block = function () {

	$('.tip-block').slick({
		slidesToShow: 1,
		centerPadding: '0',
		adaptiveHeight: true,
		nextArrow: '<span class="slick-next"></span>',
		prevArrow: '<span class="slick-prev"></span>',
	});

};
